import { message } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { ERROR, SUCCESS } from '../constants/notifications'

// TODO cleanup notifications after some time

interface Props {
  notifications: any[]
  defaultDuration?: number
}

class Notifications extends React.Component<Props> {
  state = {
    defaultDuration: 5,
  }

  componentDidUpdate() {
    const { notifications, defaultDuration } = this.props
    notifications.forEach((notification) => {
      switch (notification.kind) {
        case ERROR:
          message.error(notification.message, notification.duration || defaultDuration)
          break
        case SUCCESS:
          message.success(notification.message, notification.duration || defaultDuration)
          break
        default:
          break
      }
    })
  }

  render() {
    return null
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  notifications: state.notifications.show,
})

export default connect(mapStateToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/components/Notifications.tsx